import script from "./Design.vue?vue&type=script&setup=true&lang=js"
export * from "./Design.vue?vue&type=script&setup=true&lang=js"

import "./Design.vue?vue&type=style&index=0&id=3986b86c&lang=css"

const __exports__ = script;

export default __exports__